// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"_8xByl9KEJPK3MmI8NiwM8","title":"_3cSFIhj5m1A8ucBhmLZWnH","description":"_35bg6u7tst7_bJ2_gMdizj","cancelButton":"_3O6dArlTbQ8hGPFIrRpTJb"};